import { VideoPlayer } from '@/components/VideoPlayer';
import { UploadFileMetadata } from './UploadFileMetadata';
import { SourceUploadModalPreviewUnavailable } from './SourceUploadModalPreviewUnavailable';
import { UploadFile } from '@/types/source-modal';

interface SourceUploadModalFileSettingsProps {
    file: UploadFile;
    currentPlaybackTime: number;
    onTimeUpdate: (time: number) => void;
    onDurationChange: (duration: number) => void;
    onTrimChange: (start: number, end: number) => void;
    onThumbnailsGenerated: (thumbnails: string[]) => void;
    onFileNameChange: (name: string) => void;
    onFaceRecognitionChange: (enabled: boolean) => void;
    onLicensePlateRecognitionChange: (enabled: boolean) => void;
    onOpticalCharacterRecognitionChange: (enabled: boolean) => void;
    onAnalysisFramesPerSecondChange: (value: number) => void;
}

export function SourceUploadModalFileSettings({
    file,
    onTimeUpdate,
    onDurationChange,
    onFileNameChange,
    onFaceRecognitionChange,
    onLicensePlateRecognitionChange,
    onOpticalCharacterRecognitionChange,
    onAnalysisFramesPerSecondChange,
}: SourceUploadModalFileSettingsProps) {
    return (
        <>
            <div className="w-full bg-black rounded overflow-visible flex-shrink-0">
                {file.previewError ? (
                    <SourceUploadModalPreviewUnavailable
                        fileName={file.fileName}
                        fileSize={file.fileSize}
                    />
                ) : (
                    <VideoPlayer
                        src={file.previewUrl}
                        onTimeUpdate={onTimeUpdate}
                        onDurationChange={onDurationChange}
                    />
                )}
            </div>

            <UploadFileMetadata
                fileName={file.fileName}
                onFileNameChange={onFileNameChange}
                faceRecognition={file.faceRecognition}
                onFaceRecognitionChange={onFaceRecognitionChange}
                licensePlateRecognition={file.licensePlateRecognition}
                onLicensePlateRecognitionChange={
                    onLicensePlateRecognitionChange
                }
                opticalCharacterRecognition={file.opticalCharacterRecognition}
                onOpticalCharacterRecognitionChange={
                    onOpticalCharacterRecognitionChange
                }
                analysisFramesPerSecond={file.analysisFramesPerSecond}
                onAnalysisFramesPerSecondChange={
                    onAnalysisFramesPerSecondChange
                }
            />
        </>
    );
}
